(function() {
  function h(s) {
    return s.split('').reduce((a, c) => c.charCodeAt(0) + ((a << 5) - a), 0);
  }

  function r(seed) {
    const x = Math.sin(seed) * 10000;
    return Math.abs(x % 1); // Always [0,1)
  }

  function t() {
    const d = new Date();
    return `${d.getUTCFullYear()}-${d.getUTCMonth()}-${d.getUTCDate()}-${d.getUTCHours()}`;
  }

  function o(handle) {
    const k = `orders-${handle}`;
    const hKey = t();
    const cached = sessionStorage.getItem(k);

    if (cached) {
      const j = JSON.parse(cached);
      if (j.hour === hKey) return j.count;
    }

    const s = h(handle + hKey);
    const v = r(s);

    const c = Math.min(80, Math.floor(v * 61) + 20); // Always between 20–80

    sessionStorage.setItem(k, JSON.stringify({ hour: hKey, count: c }));
    return c;
  }

  const p = location.pathname.split('/products/')[1];
  const count = o(p);

  const wait = setInterval(() => {
    const el = document.getElementById('orders-placed-msg');
    if (el) {
      el.textContent = `🔥 ${count.toLocaleString()} orders placed in last 1 hour`;
      clearInterval(wait);
    }
  }, 200);
})();
